import { render, staticRenderFns } from "./jala-harvest.vue?vue&type=template&id=71b3f161&"
import script from "./jala-harvest.vue?vue&type=script&lang=js&"
export * from "./jala-harvest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports